import {AppThunkCreator} from "../Store";

import {IAlertState} from "../../../app/modules/alerts";
import {IdItem} from "../utils/createEntityStruct";
import {actions} from "../../../app/modules/alerts";

export const addAlert: AppThunkCreator<IAlertState & IdItem> = (alert) => (dispatch, getState) => {
    dispatch(actions.addAlert(alert));
}